import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { MessageCard, Loader, ContainerControlSite, Content, Title, i18n, tokens } from '@simplybenefits/sb-ui-library';
import AccountList from '../AccountList.js';
import * as events from '../../../../services/events';

class ActiveAccounts extends Component {
    state = {
        activeAccounts: []
    };

    componentDidMount() {
        const activeAccounts = [];

        this.props.accounts.map((account) => {
            if (account.status === 1 || account.status === 3) {
                activeAccounts.push(account);
            }

            return null;
        });

        this.setState({
            activeAccounts
        });

        events.record('view_active_accounts');
    }

    render() {
        const { whitelabel } = this.props;

        return (
            <ContainerControlSite>
                <Content>
                    <Title title={ i18n.t(tokens.titles.activeAccounts) } />

                    {
                        this.state.activeAccounts.length === 0 ?
                            (
                                <MessageCard
                                    title={ i18n.t(tokens.labels.advisor.noActiveAccounts) }
                                    subtitle={ i18n.t(tokens.labels.advisor.youHaveNotFinalizedAccounts) }
                                />
                            )
                            :
                            (
                                <AccountList accounts={this.state.activeAccounts} />
                            )}
                </Content>
                

                {this.props.loading && <Loader whitelabel={ whitelabel } />}

                <span id="accounts-active" />
            </ContainerControlSite>
        );
    }
}

ActiveAccounts.propTypes = {
    loading: PropTypes.bool,
    accounts: PropTypes.array,
    whitelabel: PropTypes.object
};

/**
 * @param state
 * @returns {{accounts: Array, loading: boolean}}
 */
const mapStateToProps = (state) => ({
    loading: state.advisor.loading,
    accounts: state.advisor.accounts,
    whitelabel: state.whitelabel
});

export default (connect(mapStateToProps)(ActiveAccounts));